module.exports = __webpack_public_path__ + "img/message_3.4a566ba7.png";